<template>
  <div class="col-12">
    <div
      style="font-size: 18px"
      class="q-mb-lg text-brand-1 text-weight-medium"
    >
      <span>Utilize os campos para filtrar a lista de submenus</span>
    </div>
    <div class="row col-12 items-center text-brand-1 text-weight-bold q-mb-sm">
      <div class="row col q-gutter-x-md">
        <div class="col-2">
          <div>Nome</div>
          <q-input
            label-color="grey-6"
            label="Digite o nome para filtrar"
            dense
            outlined
            debounce="500"
            v-model="filtros.nome"
          />
        </div>
        <div class="col-2">
          <div>Rota</div>
          <q-input
            label-color="grey-6"
            label="Digite a rota para filtrar"
            dense
            outlined
            debounce="500"
            v-model="filtros.rota"
          />
        </div>
        <div class="col-2">
          <div>Descrição</div>
          <q-input
            label-color="grey-6"
            label="Digite a rota para filtrar"
            dense
            outlined
            debounce="500"
            v-model="filtros.descricao"
          />
        </div>
      </div>
      <div>
        <p></p>
        <q-btn
          no-caps
          label="Baixar Todas Páginas"
          color="blue"
          icon="file_download"
          @click="baixarPaginasJson()"
        />
      </div>
    </div>
    <q-linear-progress v-if="loading" indeterminate size="3px" />
    <q-table
      class="my-sticky-dynamic col-12"
      :columns="columns"
      dense
      :rows="listaPaginas"
      row-key="nome"
      selection="single"
      no-data-label="Nenhum submenu criado."
      flat
      v-model:selected="selected"
      v-model:pagination="pagination"
      :hide-bottom="listaPaginas.length > 0"
    >
      <template v-slot:header="props">
        <q-tr :props="props">
          <q-th v-for="col in props.cols" :key="col.name" :props="props">
            {{ col.label }}
          </q-th>
        </q-tr>
      </template>
      <template v-slot:body="props">
        <q-tr>
          <q-td>
            <span> {{ props.row.nome }}</span>
          </q-td>
          <q-td>
            <span> {{ props.row.rota }}</span>
          </q-td>
          <q-td>
            <div>
              <span v-if="!props.selected"> {{ props.row.descricao }}</span>
              <q-input
                v-else
                class="input-tabela"
                v-model="props.row.descricao"
                dense
                outlined
              />
            </div>
          </q-td>
          <q-td>
            <div>
              <q-icon
                class="q-ml-xs"
                v-if="!props.selected"
                :name="props.row?.icone"
                size="sm"
              ></q-icon>
              <q-input
                v-else
                class="input-tabela"
                v-model="props.row.icone"
                dense
                outlined
              />
            </div>
          </q-td>
          <q-td class="coluna-btn">
            <q-btn
              v-if="!props.selected"
              icon="edit"
              flat
              round
              color="primary"
              @click="(props.selected = true), (pagina = { ...props.row })"
            />
            <q-btn
              v-else
              icon="done"
              flat
              round
              color="positive"
              @click="editarPagina(props.row)"
            />
          </q-td>
          <q-td class="coluna-btn">
            <q-btn
              icon="delete"
              flat
              round
              color="red"
              @click="excluirPagina(props.row.nome)"
            />
          </q-td>
        </q-tr>
      </template>
    </q-table>
    <div
      v-if="listaPaginas.length > 14 || pagination.page > 1"
      class="row justify-center q-mt-md"
    >
      <q-pagination
        :disable="disable"
        v-model="pagination.page"
        color="brand-5"
        active-color="secondary"
        active-text-color="white"
        :max="pagesNumber"
        :max-pages="5"
        :boundary-numbers="false"
        :direction-links="true"
        size="sm"
      />
    </div>
    <ModalInformacoesAdicionais
      :rightDrawerOpen="modal"
      @fecharModal="fecharModal"
      :nomeModal="'Adicionar Submenu'"
      :classTitulo="'text-brand-1'"
    >
      <template v-slot:conteudo-modal>
        <div v-if="!criarEmMassa">
          <div class="text-brand-1">
            <div>Nome</div>
            <q-input
              ref="inputNome"
              v-model="paginaCriar.nome"
              dense
              outlined
            />
          </div>
          <div class="text-brand-1 q-mt-sm">
            <div>Rota</div>
            <q-input v-model="paginaCriar.rota" dense outlined />
          </div>
          <div class="text-brand-1 q-mt-sm">
            <div>Descrição</div>
            <q-input v-model="paginaCriar.descricao" dense outlined />
          </div>
          <div class="text-brand-1 q-mt-sm">
            <div>
              Ícone
              <a
                class="text-brand-1"
                target="_blank"
                href="https://fonts.google.com/icons?icon.set=Material+Icons"
              >
                <q-icon style="cursor: pointer" name="info" size="18px" />
              </a>
            </div>
            <q-input v-model="paginaCriar.icone" dense outlined />
          </div>
          <div class="text-brand-1 row col-12 justify-center q-mt-md">
            <q-icon
              v-if="paginaCriar.icone"
              :name="paginaCriar.icone"
              size="sm"
            />
            <div v-else>Digite para visualizar o ícone</div>
          </div>
        </div>
        <div v-else class="row items-center text-bold q-mt-sm">
          <q-btn
            icon="file_upload"
            color="primary"
            class="btn-upload"
            no-caps
            label="Selecionar Arquivo"
            @click="abrirDialogoArquivo()"
          />
          <span class="q-ml-xs" v-if="file != null">
            <span>
              <span v-if="file?.name.length < 22">
                <span class="texto-upload">{{ file?.name }}</span>
              </span>
              <span v-else>
                <span class="texto-upload"
                  >{{ file?.name.substring(0, 22) }}...</span
                >
                <q-tooltip>{{ file.name }}</q-tooltip>
              </span>
            </span>
          </span>
          <span v-else class="q-ml-xs texto-upload"
            >Nenhum Arquivo Selecionado</span
          >
        </div>
        <div class="text-brand-1 q-mt-sm">
          <q-toggle v-model="criarEmMassa" label="Criar Em Massa" />
        </div>
      </template>
      <template v-slot:botao-modal>
        <div>
          <q-btn
            label="Criar"
            icon="done"
            color="positive"
            no-caps
            @click="criarEmMassa ? criarPaginasEmMassa() : criarPagina()"
          />
          <!-- <q-btn
            class="q-ml-sm"
            label="Criar Todas Existentes"
            icon="done"
            color="positive"
            no-caps
            @click="criarTodasPaginasExistente()"
          /> -->
        </div>
      </template>
    </ModalInformacoesAdicionais>
    <div v-if="modal" @click="fecharModal()" class="mascara"></div>
  </div>
</template>

<script>
import { computed, onMounted, ref, watch } from "vue";
import { watchDebounced } from "@vueuse/core";
import { useStore } from "vuex";
import { useQuasar } from "quasar";
import routes from "@/router/routes";

import ModalInformacoesAdicionais from "../../requisicao/components/ModalInformacaoesAdicionais.vue";

const columns = [
  {
    name: "nome",
    label: "Nome",
    align: "left",
  },
  {
    name: "rota",
    label: "Rota",
    align: "left",
  },
  {
    name: "descricao",
    label: "Descrição",
    align: "left",
  },
  {
    name: "icone",
    label: "Ícone",
    align: "left",
  },
  {
    name: "editar",
    label: "Editar",
    align: "left",
  },
  {
    name: "excluir",
    label: "Excluir",
    align: "left",
  },
];
export default {
  props: {
    modal: {
      type: Boolean,
    },
  },
  emits: ["fecharModal"],
  components: {
    ModalInformacoesAdicionais,
  },
  setup(props, { emit }) {
    const store = useStore();
    const quasar = useQuasar();

    const listaPaginas = ref([]);
    const pagina = ref({});
    const selected = ref([]);
    const disable = ref(false);
    const pagination = ref({
      sortBy: "desc",
      descending: false,
      page: 1,
      rowsPerPage: 10,
      rowsNumber: 6,
    });
    const filtros = ref({
      nome: "",
      rota: "",
      descricao: "",
    });
    const loading = ref(false);
    const paginaCriar = ref({
      nome: "",
      descricao: "",
      rota: "",
      icone: "",
    });
    const file = ref(null);
    const criarEmMassa = ref(false);
    const inputNome = ref(null);

    const criarPagina = async () => {
      if (paginaCriar.value.nome === "") {
        quasar.notify({
          message: "O campo nome não pode ser vazio.",
          color: "negative",
          actions: [
            {
              label: "fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        return;
      }
      if (paginaCriar.value.rota === "") {
        quasar.notify({
          message: "O campo rota não pode ser vazio.",
          color: "negative",
          actions: [
            {
              label: "fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        return;
      }
      try {
        await store.dispatch("office/criarPagina", {
          nome: paginaCriar.value.nome,
          rota: paginaCriar.value.rota,
          descricao: paginaCriar.value.descricao,
          icone:
            paginaCriar.value.icone != "" ? paginaCriar.value.icone : "done",
        });
        listarPaginas();
        resetPaginaCriar();
        fecharModal();
        quasar.notify({
          message: "Página criada com sucesso.",
          color: "positive",
          actions: [
            {
              label: "fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      } catch (error) {
        console.log(error);
      }
    };

    const fecharModal = () => {
      emit("fecharModal");
    };

    const listarPaginas = async (perPage = 15, page = 1) => {
      disable.value = true;
      loading.value = true;
      try {
        const response = await store.dispatch("office/listarPaginas", {
          perPage,
          page,
          rota: filtros.value.rota,
          nome: filtros.value.nome,
          descricao: filtros.value.descricao,
        });

        listaPaginas.value = response.data.resultado.dados;
        pagination.value.page = response.data.resultado.currentPage;
        pagination.value.rowsNumber = response.data.resultado.total;
        pagination.value.rowsPerPage = response.data.resultado.perPage;
        disable.value = false;
        loading.value = false;
      } catch (error) {
        console.log(error);
        disable.value = false;
        loading.value = false;
      }
    };

    const editarPagina = async (value) => {
      if (
        value.descricao === pagina.value.descricao &&
        value.icone === pagina.value.icone
      ) {
        selected.value = [];
        return;
      }
      try {
        await store.dispatch("office/editarPagina", {
          paginaNome: value.nome,
          descricao: value.descricao,
          icone: value.icone,
        });
        selected.value = [];
        listarPaginas(pagination.value.rowsPerPage, pagination.value.page);
        quasar.notify({
          message: "Página editada com sucesso.",
          color: "positive",
          actions: [
            {
              label: "fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      } catch (error) {
        console.log(error);
      }
    };

    const excluirPagina = async (paginaNome) => {
      try {
        await store.dispatch("office/excluirPagina", {
          paginaNome,
        });
        listarPaginas(pagination.value.rowsPerPage, pagination.value.page);
        quasar.notify({
          message: "Página excluída com sucesso.",
          color: "positive",
          actions: [
            {
              label: "fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      } catch (error) {
        console.log(error);
      }
    };

    const resetPaginaCriar = () => {
      paginaCriar.value = {
        nome: "",
        descricao: "",
        rota: "",
        icone: "",
      };
    };

    const baixarPaginasJson = async () => {
      try {
        const response = await store.dispatch("office/listarPaginas", {
          perPage: 100000,
          page: 1,
        });

        if (response.data.resultado.dados.length < 0) {
          return;
        }

        let json = JSON.stringify(response.data.resultado.dados, null, 2);

        let element = document.createElement("a");
        element.setAttribute(
          "href",
          "data:text/json;charset=utf-8," + encodeURIComponent(json)
        );
        element.setAttribute("download", "paginas");

        element.style.display = "none";
        document.body.appendChild(element);

        element.click();

        document.body.removeChild(element);
      } catch (error) {
        console.log(error);
      }
    };

    const abrirDialogoArquivo = () => {
      const fileInput = document.createElement("input");
      fileInput.type = "file";
      fileInput.style.display = "none";
      fileInput.addEventListener("change", handleFileChange);
      document.body.appendChild(fileInput);
      fileInput.click();
    };

    const handleFileChange = (event) => {
      file.value = event.target.files[0];
      event.target.removeEventListener("change", handleFileChange);
      event.target.remove();
    };

    const criarPaginasEmMassa = () => {
      if (file.value == null) {
        quasar.notify({
          message: "Selecione um arquivo.",
          color: "negative",
          actions: [
            {
              label: "fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        return;
      }

      let conteudo = "";
      let reader = new FileReader();

      reader.onload = async function (event) {
        try {
          conteudo = event.target.result;
          const response = await store.dispatch("office/criarPaginaEmMassa", {
            paginas: JSON.parse(conteudo),
          });
          quasar.notify({
            message: response.data.resultado?.mensagem,
            color: "positive",
            actions: [
              {
                label: "fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
          file.value = null;
          fecharModal();
          listarPaginas();
          criarEmMassa.value = false;
        } catch (error) {
          if (
            error?.response?.data?.erros?.mensagem == "erro ao criar páginas."
          ) {
            quasar.notify({
              message: error?.response?.data?.erros?.mensagem,
              color: "negative",
              actions: [
                {
                  label: "fechar",
                  color: "white",
                  handler: () => {
                    /* ... */
                  },
                },
              ],
            });
            error?.response?.data?.erros?.resultado.forEach((pagina) => {
              quasar.notify({
                message: `Já existe uma página com esse nome cadastrado: ${pagina.pagina.nome}`,
                color: "negative",
                actions: [
                  {
                    label: "fechar",
                    color: "white",
                    handler: () => {
                      /* ... */
                    },
                  },
                ],
              });
            });
          }
          if (
            error?.response?.data?.erros?.mensagem ==
            "criação parcialmente concluida."
          ) {
            quasar.notify({
              message: error?.response?.data?.erros?.mensagem,
              color: "positive",
              actions: [
                {
                  label: "fechar",
                  color: "white",
                  handler: () => {
                    /* ... */
                  },
                },
              ],
            });
            error?.response?.data?.erros?.resultado.forEach((pagina) => {
              quasar.notify({
                message: `Já existe uma página com esse nome cadastrado: ${pagina.pagina.nome}`,
                color: "negative",
                actions: [
                  {
                    label: "fechar",
                    color: "white",
                    handler: () => {
                      /* ... */
                    },
                  },
                ],
              });
            });
            file.value = null;
            fecharModal();
            listarPaginas();
            criarEmMassa.value = false;
          }
        }
      };
      reader.readAsText(file.value);
    };

    const criarTodasPaginasExistente = async () => {
      let rotas = routes[0].children;
      const arrayPaginas = [];

      rotas.forEach((submenu) => {
        if (submenu?.children?.length > 0) {
          submenu.children.forEach((pagina) => {
            if (pagina.meta.show) {
              arrayPaginas.push({
                nome: pagina.name,
                rota: pagina.path,
                descricao: pagina?.meta.label,
                icone: pagina.meta?.icon,
              });
            }
          });
        }
      });
      try {
        const response = await store.dispatch("office/criarPaginaEmMassa", {
          paginas: arrayPaginas,
        });
        quasar.notify({
          message: response.data.resultado?.mensagem,
          color: "positive",
          actions: [
            {
              label: "fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        fecharModal();
        listarPaginas();
        criarEmMassa.value = false;
      } catch (error) {
        if (
          error?.response?.data?.erros?.mensagem == "erro ao criar páginas."
        ) {
          quasar.notify({
            message: error?.response?.data?.erros?.mensagem,
            color: "negative",
            actions: [
              {
                label: "fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
          error?.response?.data?.erros?.resultado.forEach((pagina) => {
            quasar.notify({
              message: `Já existe uma página com esse nome cadastrado: ${pagina.pagina.nome}`,
              color: "negative",
              actions: [
                {
                  label: "fechar",
                  color: "white",
                  handler: () => {
                    /* ... */
                  },
                },
              ],
            });
          });
        }
        if (
          error?.response?.data?.erros?.mensagem ==
          "criação parcialmente concluida."
        ) {
          quasar.notify({
            message: error?.response?.data?.erros?.mensagem,
            color: "positive",
            actions: [
              {
                label: "fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
          error?.response?.data?.erros?.resultado.forEach((pagina) => {
            quasar.notify({
              message: `Já existe uma página com esse nome cadastrado: ${pagina.pagina.nome}`,
              color: "negative",
              actions: [
                {
                  label: "fechar",
                  color: "white",
                  handler: () => {
                    /* ... */
                  },
                },
              ],
            });
          });
          file.value = null;
          fecharModal();
          listarPaginas();
          criarEmMassa.value = false;
        }
      }
    };

    watch(
      () => inputNome?.value,
      () => {
        if (
          inputNome?.value != null &&
          props.modal &&
          paginaCriar.value.nome == ""
        ) {
          inputNome.value?.focus();
        }
      }
    );

    watch(
      () => props.atualizar,
      () => {
        listarPaginas(pagination.value.rowsPerPage, pagination.value.page);
      }
    );

    watch(
      () => pagination.value.page,
      () => {
        listarPaginas(pagination.value.rowsPerPage, pagination.value.page);
      }
    );

    watchDebounced(
      [
        () => filtros.value.nome,
        () => filtros.value.rota,
        () => filtros.value.descricao,
      ],
      () => {
        listarPaginas();
      },
      { debounce: 400 }
    );

    onMounted(() => {
      listarPaginas();
    });

    return {
      columns,
      listarPaginas,
      listaPaginas,
      excluirPagina,
      editarPagina,
      paginaCriar,
      pagina,
      filtros,
      criarPaginasEmMassa,
      file,
      selected,
      disable,
      fecharModal,
      abrirDialogoArquivo,
      handleFileChange,
      criarTodasPaginasExistente,
      baixarPaginasJson,
      criarEmMassa,
      resetPaginaCriar,
      loading,
      criarPagina,
      inputNome,
      pagination,
      pagesNumber: computed(() =>
        Math.ceil(pagination.value.rowsNumber / pagination.value.rowsPerPage)
      ),
    };
  },
};
</script>

<style scoped>
a {
  text-decoration: none;
}
.q-table__top,
thead tr:first-child th {
  background-color: #d9effc;
}

thead tr th {
  position: sticky;
  z-index: 1;
}
thead tr:first-child th {
  top: 0;
}

.q-table--loading thead tr:last-child th {
  top: 48px;
}
.my-sticky-dynamic {
  max-height: 400px;
}
thead tr th {
  position: sticky;
  z-index: 1;
}
thead tr:last-child th {
  top: 48px;
}
thead tr:first-child th {
  top: 0;
}
.input-tabela {
  width: 180px;
}
tbody tr .coluna-btn {
  width: 120px;
}
tbody tr td {
  white-space: pre-wrap;
}
.mascara {
  background-color: black;
  height: 100%;
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 2;
  opacity: 0.4;
}
</style>
